/* eslint-disable import/prefer-default-export */

import axios from 'axios';

import { CONVERSATION_UPDATE } from '../constants/conversationConstants';

export const updateConversation = conversation => ({
    type: CONVERSATION_UPDATE,
    conversation,
});